import React from "react";
import styled from "styled-components";
import colors from "./colors";
import { media, sizes } from "./utils";

const ModalHeader = styled.header`
  width: 100%;
  height: 11.25rem;
  margin: 0 0 1.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const Header = styled(ModalHeader)`
  height: auto;
  min-height: calc(100vh - 3.75rem);
  ${props => props.narrow &&
    `
      height: 7.8125rem;
      min-height: 7.8125rem;
  `};
  ${media.desktopNarrow`
    min-height: calc(100vh - 5.3125rem);
    ${props => props.narrow &&
    `
      min-height: 20.625rem;
    `};
    ${props => props.stripeMedium &&
    `
      min-height: 30.625rem;
    `};
  `}
  ${media.maxWidth(sizes.tabletWide)`
    ${props => props.stripe &&
      `
        height: 9.5rem;
        min-height: 9.5rem;
      `
    };
  `}
  ${media.minWidth(sizes.tabletWide+1)`
    ${props => props.stripe &&
      `
        height: 20.625rem;
        min-height: 20.625rem;
      `
    };
  `}

    ${props => props.stripeMedium &&
      `
      height: auto;
      min-height: auto;
      
  `}
  margin-bottom: 0;
  padding-top: 0;
  align-items: center;
  justify-content: center;
  ${media.maxHeight(700)`
    padding-top: 2rem;
    align-items: start;
    justify-content: start;
  `}
  ${media.tabletNarrow`
      padding-top: 0;
      align-items: center;
      justify-content: center;
  `}

  ${({autoHeight}) => autoHeight && `
    height: auto !important;
    min-height: auto !important;
  `}

  ${({paddedTop}) => paddedTop && `
    padding-top: 2rem !important;
  `}
  ${({paddedBottom}) => paddedBottom && `
    padding-bottom: 2rem !important;
  `}
  ${({bottomMargin}) => bottomMargin && `
    margin-bottom: 2rem !important;
  `}
  ${media.tabletNarrow`
    ${({homePageHeader}) => homePageHeader && `
        margin-bottom: 4rem;
    `}
  `}
`;

const ModalFigure = styled.figure`
  background: ${colors.GRAY_MEGA_LIGHT};
  ${props =>
    props.src &&
    `
    background-image: url(${props.src});
    background-position: 50% 50%;
    background-size: cover;
  `} overflow: hidden;
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;

  position: absolute;
  width: 100%;
  height: 100%;
`;

const Figure = styled(ModalFigure)`
  margin: 0 auto;
  left: 0;
  right: 0;
  top: 0;
  &:after {
    content: "";
    background: rgba(65, 117, 5, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  ${props => props.noOverlay &&
    `
    &:after {
      display: none;
    }
  `};
  

`;

const ModalHeaderImage = styled(({ src, ...rest }) => {
  return <ModalFigure src={src} {...rest} />;
})``;

const HeaderImage = styled(({ src, ...rest }) => {
  return <Figure style={{backgroundImage: `url(${src})`}} src={src} {...rest} />;
})``;

const ModalHeaderContent = styled.div`
  position: relative;
  display: flex;
  align-self: center;
  justify-content: center;
  padding: 0 2rem;
  align-items: center;
  flex-flow: column;
  button {
    align-self: center;
    margin: 0 auto;
    flex-grow: 0;
    flex-shrink: 0;
    background: ${colors.BRAND_GREEN};
    color: white;
    font-size: 0.8125rem;
    padding: 0.5em 0.25em 0.5em 0.5em;
    text-transform: uppercase;
    font-weight: 100;
    display: flex;
    align-items: center;

    svg {
      fill: white;
      width: 0.75em;
      height: 0.75em;
      margin-left: 0.5em;
      align-self: center;
    }
  }
`;

const HeaderContent = styled(ModalHeaderContent)``;

export {
  Header,
  HeaderImage,
  HeaderContent,
  ModalHeader,
  ModalHeaderImage,
  ModalHeaderContent
};



// WEBPACK FOOTER //
// ./src/modules/common/components/ui/PageHeader.js